import { Box, Flex } from "@acko-tech/building-blocks.ui.common";
import ImageContainer from "@components/imageContainer";
import { HeadingText, PageHeadingWithImageWrapper } from "./styles";
import { getWidgetSpecificProps } from "@utils/index";
import { connect } from "react-redux";
import { resolvePath } from "@utils/resolvePath";

const mapStateToProps = function (state: any, ownProps: any) {
  return getWidgetSpecificProps(
    state.configuration?.normalisedConfig,
    ownProps.id
  );
};

const PageHeadingWithImage = (props) => {
  const { text, src, alt, styles, imgStyles, is_visible, height=112,width=168, isResolvePath= false } = props;
  return is_visible ? (
    <PageHeadingWithImageWrapper
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
      styles={styles}
    >
      <HeadingText dangerouslySetInnerHTML={{ __html: text }}></HeadingText>
      <ImageContainer
        imgSrc={isResolvePath? resolvePath(src): src}
        height={height}
        width={width}
        styles={imgStyles}
      />
    </PageHeadingWithImageWrapper>
  ) : null;
};

export default connect(mapStateToProps)(PageHeadingWithImage);
